export const FIGHTER_USECASE_ERROR_MESSAGES = {
  RETRIEVAL_FAILED: 'Unable to load fighters. Please try again.',
};
